<template>
  <div class="h-full p-20px">
    <div class="flex flex-column h-full">
      <Tabs :datas="{'现金':'现金日记账','银行存款':'银行日记账'}" v-model="ioType" class="bg-white-color px-16px"/>
      <vxe-toolbar class-name="px-16px" :loading="loading">
        <template #buttons>
          <Button :disabled="!account" color="green" class="mr-16px" icon="fa fa-edit" @click="showForm()">记账</Button>
          <Select :datas="accountList" keyName="id" titleName="name" type="object" v-model="account" style="min-width: 200px;margin-right: 16px" :deletable="false">
            <template #show="{value}">{{ value.code }} - {{ value.name }}</template>
            <template #item="{item}">{{ item.code }} - {{ item.name }}</template>
          </Select>
          <DropdownCustom ref="journalParamsDropdown" button class="h-btn-primary" trigger="click">
            <div>{{ startDate }} 至 {{ endDate }}</div>
            <template #content>
              <Form style="padding: 10px">
                <FormItem class="!pb-5px" label="日期">
                  <div class="flex items-center">
                    <DatePicker v-model="params.start" :clearable="false" :option="{end:params.end}"/>
                    <span class="mx-8px">至</span>
                    <DatePicker v-model="params.end" :clearable="false" :option="{start:params.start}"/>
                  </div>
                </FormItem>
                <FormItem class="!pb-5px" label="收支类型">
                  <Select :datas="ioTypeOptions" filterable v-model.number="params.ioTypeId"/>
                </FormItem>
                <FormItem class="!pb-5px" label="结算方式">
                  <Select :datas="settlementTypeOptions" filterable v-model.number="params.settlementTypeId"/>
                </FormItem>
                <FormItem class="!pb-5px" label="项目">
                  <Select :datas="projectOptions" filterable v-model.number="params.projectCategoryDetailsId"/>
                </FormItem>
                <FormItem class="!pb-5px" label="部门">
                  <Select :datas="deptOptions" filterable v-model.number="params.deptCategoryDetailsId"/>
                </FormItem>
                <FormItem class="!pb-5px" label="流水号">
                  <Input v-model="params.code"/>
                </FormItem>
                <FormItem class="!pb-5px" label="往来单位">
                  <Input v-model="params.accountingCategoryDetailsValue"/>
                </FormItem>
                <FormItem class="!pb-5px" label="摘要">
                  <Input v-model="params.digest"/>
                </FormItem>
                <FormItem class="!pb-5px" label="备注">
                  <Input v-model="params.remark"/>
                </FormItem>
                <FormItem class="!pb-10px" label="金额">
                  <div class="flex items-center">
                    <NumberInput v-model="params.minMoney"/>
                    <span class="mx-8px">至</span>
                    <NumberInput v-model="params.maxMoney"/>
                  </div>
                </FormItem>
                <FormItem class="!pb-5px">
                  <Button color="primary" @click="loadList();" :loading="loading">确定</Button>
                  <Button @click="journalParamsDropdown.hide()">取消</Button>
                  <Button>重置</Button>
                </FormItem>
              </Form>
            </template>
          </DropdownCustom>
        </template>
        <template #tools>
          <Checkbox v-model="showAll" class="mr-16px">显示全部</Checkbox>
          <DropdownMenu
              button
              trigger="hover"
              @clickItem="printClickItem"
              :datas="{printBill:'打印凭据',printList:'打印列表'}">
            打印
          </DropdownMenu>
          <Button @click="importJournal" :disabled="!account">导入</Button>
          <Button @click="exportJournal" :disabled="!account">导出</Button>
          <DropdownMenu
              button
              trigger="hover"
              @clickItem="batchClickItem"
              :datas="{batchDelete:'批量删除',setIoType:'指定收支类别',setAccountingCategory:'指定往来单位',setProject:'指定项目',setDept:'指定部门'}">
            批量操作
          </DropdownMenu>
          <DropdownMenu
              button
              trigger="hover"
              class="h-btn-primary"
              @clickItem="voucherClickItem"
              :datas="{generatePreview:'生成凭证预览',generateSettings:'生成凭证设置'}">
            生成凭证
          </DropdownMenu>
        </template>
      </vxe-toolbar>
      <div class="flex-1 h-0px">
        <vxe-table ref="journalTable"
                   :checkbox-config="{visibleMethod:({ row }) => !row.init,checkMethod:({ row }) => !row.init}"
                   :loading="loading"
                   :data="dataResult.results"
                   height="auto"
                   border>
          <vxe-column type="checkbox" width="50" align="center" fixed="left"/>
          <vxe-column title="交易流水号" field="code" width="160"/>
          <vxe-column title="日记账序号" field="serialNumber" width="160">
            <template #default="{row}">
              <div @click="showEvidence(row)" class="text-hover primary-color">{{ row.serialNumber }}</div>
            </template>
          </vxe-column>
          <vxe-column title="日期" field="billDate" width="120"/>
          <vxe-column title="摘要" field="digest" width="120"/>
          <vxe-column title="收支类别" field="ioTypeValue" width="120">
            <template #default="{row}">
              <span v-if="row.cashierTransferId">内部转账</span>
              <span v-else>{{ row.ioTypeValue }}</span>
            </template>
          </vxe-column>
          <vxe-column title="往来单位" field="accountingCategoryDetailsValue" width="150"/>
          <vxe-column title="部门" field="deptName" :visible="showAll" width="100"/>
          <vxe-column title="项目" field="projectName" :visible="showAll" width="100"/>
          <vxe-column title="收入(借方)" field="debit" width="100" align="right"/>
          <vxe-column title="支出(贷方)" field="credit" width="100" align="right"/>
          <vxe-column title="余额" field="balance" width="100" align="right" :show-overflow="false">
            <template #default="{row}">
              <vxe-input class="balance-edit" :disabled="updating" v-model.number="row.balance" v-if="row.init" @blur="initialBalanceChange(row)"/>
              <span v-else>{{ row.balance }}</span>
            </template>
          </vxe-column>
          <vxe-column title="结算方式" field="settlementTypeTitle" width="120" :visible="showAll"/>
          <vxe-column title="票据号" field="billNo" width="120" :visible="showAll"/>
          <vxe-column title="备注" field="remark" width="120" :visible="showAll"/>
          <vxe-column title="关联凭证" field="voucherCode" width="80" align="center">
            <template #default="{row}">
              <router-link class="text-hover primary-color" width="1024px"
                           v-if="row.voucherId"
                           :to="{name:'VoucherForm',params:{voucherId:row.voucherId}}">
                {{ row.voucherCode }}
              </router-link>
            </template>
          </vxe-column>
          <vxe-column title="操作" width="120">
            <template #default="{row}">
              <div class="actions" v-if="!row.init && !row.cashierTransferId">
                <span v-if="!row.voucherId" @click="showForm(row)" class="fa fa-edit">编辑</span>
                <span v-if="!row.voucherId" @click="doTrash(row)" class="fa fa-trash">删除</span>
              </div>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
      <vxe-pager @page-change="onPageChange"
                 v-model:current-page="page.page"
                 v-model:page-size="page.pageSize"
                 :total="dataResult.total"
                 :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
        <template #left>
          <vxe-button @click="loadList()" type="text" size="mini" icon="fa fa-refresh" :loading="loading"></vxe-button>
        </template>
      </vxe-pager>
    </div>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */

export default {
	name: "CashierJournal"
}
</script>
<script setup>
import {ref, h, watch, reactive} from "vue";
import manba from "manba";
import {confirm, message} from "heyui.ext";
import {useStore} from 'vuex'
import CashierAccount from "@/api/CashierAccount";
import CashierIoType from "@/api/CashierIoType";
import {layer} from "@layui/layer-vue";
import CashierJournalForm from "@/views/cashier/CashierJournalForm";
import CashierJournal from "@/api/CashierJournal";
import setting from "@/api/setting";
import CashierJournalEvidence from "@/views/cashier/CashierJournalEvidence";
import Qs from "qs";
import CashierJournalBatchUpdate from "@/views/cashier/CashierJournalBatchUpdate";
import CashierIoTypeTemplate from "@/views/cashier/CashierIoTypeTemplate";
import CashierJournalVoucherPreview from "@/views/cashier/CashierJournalVoucherPreview";
import CashierAccountForm from "@/views/cashier/CashierAccountForm";
import CashierImport from "@/views/cashier/CashierImport.vue";

const store = useStore();

const accountList = ref([]);
const ioTypeMap = reactive({});
const ioTypeOptions = ref([]);
const settlementTypeOptions = ref([]);
const projectOptions = ref([]);
const deptOptions = ref([]);
const account = ref(null);
const journalTable = ref(null);
const journalParamsDropdown = ref(null);
const loading = ref(false);
const ioType = ref('现金');

const currentAccountDate = manba(store.state.currentAccountSets.currentAccountDate);
const startDate = ref(currentAccountDate.startOf(manba.MONTH).format());
const endDate = ref(currentAccountDate.endOf(manba.MONTH).format());

const updating = ref(false);
const showAll = ref(false);

const page = ref({
	page: 1,
	pageSize: 20
})

const dataResult = ref({
	results: [],
	total: 20
})

const params = reactive({
	start: startDate.value,
	end: endDate.value,
	ioTypeId: null,
	settlementTypeId: null,
	projectCategoryDetailsId: null,
	deptCategoryDetailsId: null,
	code: null,
	minMoney: null,
	maxMoney: null,
	accountingCategoryDetailsValue: null,
	digest: null,
	remark: null,
});

const onPageChange = ({currentPage, pageSize}) => {
	page.value.page = currentPage;
	page.value.pageSize = pageSize;
	loadList();
}


const loadAccountList = () => {
	loading.value = true
	CashierAccount.list().then(({data}) => {
		accountList.value = data.filter(val => val.type === ioType.value);
		if (accountList.value.length) {
			account.value = account.value ? accountList.value.find(val => val.id === account.value.id) : accountList.value[0];
		}
	}).finally(() => loading.value = false)
}

loadAccountList();

CashierIoType.list().then(({data}) => {
	ioTypeOptions.value = data.map(val => {
		ioTypeMap[val.id] = val;
		return {
			key: val.id,
			title: val.type + "-" + val.code + "-" + val.name
		}
	});
})

setting.accountSets.getSettlementTypeList().then(({data}) => {
	settlementTypeOptions.value = data.map(val => {
		return {
			key: val.id,
			title: val.title
		}
	});
})

setting.accountingCategory.list().then(({data}) => {
	const categorys = (data || []).filter(val => ['部门', '项目'].includes(val.name));
	if (categorys.length) {
		setting.accountingCategoryDetails.loadAuxiliaryAccountingData(categorys).then(({data}) => {
			let dept = categorys.find(value => value.name === '部门');
			deptOptions.value = data[dept.id].map(val => {
				return {
					key: val.id,
					accountingCategoryId: val.accountingCategoryId,
					title: val.name
				}
			});
			let project = categorys.find(value => value.name === '项目');
			projectOptions.value = data[project.id].map(val => {
				return {
					key: val.id,
					accountingCategoryId: val.accountingCategoryId,
					title: val.name
				}
			});
		})
	}
})

const initialBalanceChange = (row) => {
	updating.value = true;
	CashierJournal.save({id: row.id, balance: row.balance}).then(() => {
		loadList();
	}).finally(() => updating.value = false)
}

const loadList = () => {
	if (account.value) {
		loading.value = true
		CashierJournal.list(account.value.id, Object.assign(params, page.value)).then(({data}) => {
			dataResult.value = data;
			startDate.value = params.start;
			endDate.value = params.end;
			journalParamsDropdown.value.hide();
		}).finally(() => loading.value = false)
	}
}

const showForm = (entity = null) => {
	let layerId = layer.open({
		title: account.value.name + "日记账",
		shadeClose: false,
		closeBtn: false,
		area: ['700px', 'auto'],
		zIndex: 1000,
		content: h(CashierJournalForm, {
			entity, account, startDate, endDate, ioTypeOptions,
			ioTypeMap, settlementTypeOptions, deptOptions, projectOptions,
			onClose: () => {
				layer.close(layerId);
			},
			onSuccess: () => {
				loadList();
				layer.close(layerId);
			}
		})
	});
}

const doTrash = (row) => {
	confirm({
		content: `确认删除此记录?`,
		onConfirm: () => {
			loading.value = true;
			CashierJournal.delete(row.id).then(() => {
				loadList();
			}).finally(() => loading.value = false)
		}
	})
}

const showEvidence = (journal) => {
	layer.open({
		title: journal.serialNumber,
		closeBtn: 2,
		area: ['1100px', 'auto'],
		content: h(CashierJournalEvidence, {
			journal, account: account.value
		})
	});
}

const printClickItem = (key) => {
	let records = journalTable.value.getCheckboxRecords().map(row => row.id);
	switch (key) {
		case "printBill":
			if (records.length) {
				window.open("/api/pdf/journal?journal=" + records.join("&journal="))
			} else {
				message("请选择需要打印的记录~")
			}
			break
		case "printList":
			window.open("/api/pdf/journal/list/" + account.value.id + "?" + Qs.stringify(Object.assign(params, page.value)))
			break
	}
}

const exportJournal = () => {
	window.open("/api/cashier/journal/download/" + account.value.id + "?" + Qs.stringify(Object.assign(params, page.value)))
}

const importJournal = () => {
	let layerId = layer.open({
		title: account.value.name + "日记账导入",
		shadeClose: false,
		closeBtn: false,
		zIndex: 1000,
		area: ['5 00px', 'auto'],
		content: h(CashierImport, {
			account: account.value,
			ioType: ioType.value,
			onClose: () => {
				layer.close(layerId);
			},
			onSuccess: () => {
				layer.close(layerId);
			}
		})
	});
}

const batchClickItem = (type) => {
	let records = journalTable.value.getCheckboxRecords().map(row => row.id);
	if (records.length) {
		switch (type) {
			case 'batchDelete':
				confirm({
					content: `确认删除这些记录?`,
					onConfirm: () => {
						loading.value = true;
						CashierJournal.batchDelete(records).then(() => {
							loadList();
						}).finally(() => loading.value = false)
					}
				})
				break
			case 'setIoType':
			case 'setAccountingCategory':
			case 'setProject':
			case 'setDept':
				let layerId = layer.open({
					title: "批量更新",
					shadeClose: false,
					closeBtn: false,
					area: ['400px', 'auto'],
					zIndex: 1000,
					content: h(CashierJournalBatchUpdate, {
						records, type, ioTypeOptions,
						ioTypeMap, settlementTypeOptions, deptOptions, projectOptions,
						onClose: () => {
							layer.close(layerId);
						},
						onSuccess: () => {
							loadList();
							layer.close(layerId);
						}
					})
				});
				break
		}
	} else {
		message("请选择需要操作的记录~")
	}
}

const voucherClickItem = (key) => {
	if (key === 'generatePreview') {
		let records = journalTable.value.getCheckboxRecords();
		if (records.length && records.every(val => !val.voucherId)) {
			if (account.value.subjectId) {
				let layerId = layer.drawer({
					title: account.value.name + " 凭证预览",
					zIndex: 1000,
					area: ['1000px', '100vh'],
					content: h(CashierJournalVoucherPreview, {
						records, account: account.value,
						onClose: () => {
							layer.close(layerId);
						},
						onSuccess: () => {
							layer.close(layerId);
							loadList();
						}
					})
				});
			} else {
				confirm({
					content: `账户【${account.value.name}】未设置会计科目<br>不能生成预览凭证<br>是否立即设置?`,
					okText: "立即设置",
					cancelText: "稍后操作",
					onConfirm() {
						let layerId = layer.open({
							title: account.value.name + " 账户信息",
							shadeClose: false,
							closeBtn: false,
							zIndex: 1000,
							area: ['400px', 'auto'],
							content: h(CashierAccountForm, {
								entity: account.value,
								type: account.value.type,
								onClose: () => {
									layer.close(layerId);
								},
								onSuccess: () => {
									loadAccountList();
									layer.close(layerId);
								}
							})
						});
					}
				})
			}
		} else {
			message("没有选择需生成凭证的记录~")
		}
	} else if (key === 'generateSettings') {
		let layerId = layer.drawer({
			title: ioType.value + "凭证模板",
			zIndex: 1000,
			area: ['700px', '100vh'],
			content: h(CashierIoTypeTemplate, {
				ioType, account,
				onClose: () => {
					layer.close(layerId);
				},
				onSuccess: () => {
					layer.close(layerId);
				}
			})
		});
	}
}

watch(account, () => {
	loadList();
})

watch(ioType, () => {
	account.value = null;
	loadAccountList();
})

watch(showAll, () => {
	setTimeout(() => {
		journalTable.value.refreshColumn();
	}, 200)
})
</script>
